import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { NgForm } from '@angular/forms';
import { ItemProduto } from 'src/app/admihair/api/dto/item-produto';
import { Paginador } from 'src/app/admihair/api/dto/paginacao/paginador';
import { Profissional } from 'src/app/admihair/api/dto/profissional';
import { SaidaEstoque } from 'src/app/admihair/api/dto/saida-estoque';
import { Table } from 'primeng/table';
import { SaidaEstoqueService } from 'src/app/admihair/service/saida-estoque.service';
import { ItemProdutoService } from 'src/app/admihair/service/item-produto.service';
import { ProfissionalService } from 'src/app/admihair/service/profissional.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ComandaService } from 'src/app/admihair/service/comanda.service';
import { Comanda } from 'src/app/admihair/api/dto/comanda';
import { ItemComandaService } from 'src/app/admihair/service/item-comanda.service';
import { ItemComanda } from 'src/app/admihair/api/dto/item-comanda';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-saida-estoque-inserir-identificada',
  templateUrl: './saida-estoque-inserir-identificada.component.html',
  styleUrls: ['./saida-estoque-inserir-identificada.component.scss']
})
export class SaidaEstoqueInserirIdentificadaComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('f') form?: NgForm;
  @ViewChild('filter') filter!: ElementRef;

  progressoRequisicao: boolean = false;
  loadingTableItens: boolean = false;
  exibirDialogProduto: boolean = false;
  exibirSpinnerDialog: boolean = false;
  listaProdutosDialog: ItemProduto[] = [];
  itensProdutosPaginados?: Paginador<ItemProduto>;
  numeroPaginaProduto: number = 0;
  inputBusca: string = '';

  listaProfissionais: Profissional[] = [];
  profissionalSelecionado?: Profissional;

  listaComandas: Comanda[] = [];
  comandaSelecionada?: Comanda;
  exibirSpinnerComanda: boolean = false;

  servicosComanda: ItemComanda[] = [];
  servicoSelecionado?: ItemComanda;
  isServicoSelecionado: boolean = false;
  exibirSpinnerServico: boolean = false;

  dataSelecionada?: Date;

  itemProdutoSelecionado?: ItemProduto;
  quantidadeProdutoSelecionado?: number;
  listaItensSaidaEstoque: SaidaEstoque[] = [];

  constructor(private saidaEstoqueService: SaidaEstoqueService,
    private profissionalService: ProfissionalService,
    private comandaService: ComandaService,
    private itemComandaService: ItemComandaService,
    private itemProdutoService: ItemProdutoService,
    private confirmationService: ConfirmationService,
    erroService: ErroService,
    storageService: UtilStorageService,
    router: Router,
    activatedRoute: ActivatedRoute) {
    super(erroService, storageService, router, activatedRoute)
  }

  ngOnInit(): void {
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_SAIDA_ESTOQUE_IDENTIFICADA');
    if (this.permissaoInserir) {
      this.carregarProfissionais();
    }
  }

  carregarProfissionais() {
    this.profissionalService.listarAtivosPorEmpresaId(this.getEmpresa().id).subscribe({
      next: (data: Profissional[]) => {
        this.listaProfissionais = data;
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    })
  }

  carregarSaidasEstoque() {
    this.loadingTableItens = true;
    this.saidaEstoqueService.listarPorEmpresaIdEComanda(this.getEmpresa().id, this.comandaSelecionada?.id).subscribe({
      next: (data: SaidaEstoque[]) => {
        this.listaItensSaidaEstoque = data;
        this.loadingTableItens = false;
        this.carregarServicos();
      },
      error: (err: any) => {
        this.loadingTableItens = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  carregarComandas() {
    this.exibirSpinnerComanda = true;
    this.limparSelecinados();
    this.comandaService.listarComandasNaoPacotePorEmpresaEDataCaixa(this.getEmpresa().id, this.dataSelecionada).subscribe({
      next: (data: Comanda[]) => {
        this.listaComandas = data;
        this.exibirSpinnerComanda = false;
      },
      error: (err: any) => {
        this.exibirSpinnerComanda = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  limparSelecinados() {
    this.comandaSelecionada = undefined;
    this.servicoSelecionado = undefined;
    this.listaItensSaidaEstoque = [];
  }

  carregarServicos() {
    this.limparServicoSelecionado();
    this.exibirSpinnerServico = true;
    this.itemComandaService.listarItensComandaServicoPorComanda(this.comandaSelecionada?.id)
      .subscribe({
        next: (data: ItemComanda[]) => {
          this.servicosComanda = data;
          this.exibirSpinnerServico = false;
        },
        error: (err: any) => {
          this.exibirSpinnerServico = false;
          this.exibirMensagemErro(err);
        }
      })
  }

  limparServicoSelecionado() {
    this.servicoSelecionado = undefined;
    this.isServicoSelecionado = false;
  }

  selecionarServico() {
    if (this.servicoSelecionado) {
      this.isServicoSelecionado = true;
    } else {
      this.isServicoSelecionado = false;
    }
  }


  removerItemSelecionado() {
    this.itemProdutoSelecionado = undefined;
    this.profissionalSelecionado = undefined;
    this.quantidadeProdutoSelecionado = 0;
  }

  salvarSaida() {

    this.progressoRequisicao = true;
    const novaSaida: SaidaEstoque = {
      data: this.comandaSelecionada?.dataComanda,
      item: this.itemProdutoSelecionado,
      descricaoItem: this.itemProdutoSelecionado?.descricao,
      quantidade: this.quantidadeProdutoSelecionado,
      profissionalId: this.profissionalSelecionado?.id,
      nomeProfissional: this.profissionalSelecionado?.nomeProfissional,
      comandaId: this.comandaSelecionada?.id,
      itemServicoId: this.servicoSelecionado?.id,
      empresaId: this.getEmpresa().id,
      usuario: this.getUsuarioLogadoSistema().id
    }

    
    this.saidaEstoqueService.salvarSaidaJustificada(novaSaida).subscribe({
      next: () => {
        this.progressoRequisicao = false;
        this.carregarSaidasEstoque();
        this.exibirMensagemSucesso();

      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.exibirMensagemErro(err)
      }
    })


    this.itemProdutoSelecionado = undefined;
    this.quantidadeProdutoSelecionado = 0;
  }

  excluirItemSaidaAdicionado(item: SaidaEstoque) {
    const posicao = this.listaItensSaidaEstoque.indexOf(item);
    this.listaItensSaidaEstoque.splice(posicao, 1);
  }

  abrirDialogAdicionarProduto() {
    this.exibirDialogProduto = true;
    this.exibirSpinnerDialog = true;
    this.carregarItensProdutos(0);
  }

  fecharDialogAdicionarProduto() {
    this.exibirSpinnerDialog = false;
    this.exibirDialogProduto = false;
  }

  carregarItensProdutos(numeroPagina?: number) {
    const tamanhoPagina = 5;
    this.itemProdutoService
      .listarProdutoBaixaPorEmpresaPaginado(this.getEmpresa().id, numeroPagina, tamanhoPagina, this.inputBusca).subscribe({
        next: (data: Paginador<ItemProduto>) => {
          this.listaProdutosDialog = data.content;
          this.itensProdutosPaginados = data;
          this.exibirSpinnerDialog = false;
          this.loadingTableItens = false;
        },
        error: (err: any) => {
          this.exibirSpinnerDialog = false;
          this.loadingTableItens = false;
          this.exibirDialogProduto = false;
          this.exibirMensagemErro(err);
        }
      })
  }

  excluirSaida(saida: SaidaEstoque) {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.saidaEstoqueService.excluir(saida.id).subscribe({
          next: () => {
            this.carregarSaidasEstoque();
            this.exibirMensagemSucesso();
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          }
        })

      }
    });
  }

  selecionarItem(item: ItemProduto) {
    this.itemProdutoSelecionado = item;
    this.quantidadeProdutoSelecionado = 0;
    this.selecionarProfissional();
    this.exibirDialogProduto = false;
  }

  selecionarProfissional() {
    this.profissionalSelecionado = this.listaProfissionais
      .find(profissional => profissional.id === this.servicoSelecionado?.profissionalId);
  }

  buscarDialogItens(event: Event) {
    this.loadingTableItens = true;
    this.inputBusca = (event.target as HTMLInputElement).value;
    this.carregarItensProdutos(0);
  }

  limparDialogItens() {
    this.loadingTableItens = true;
    this.filter.nativeElement.value = '';
    this.inputBusca = '';
    this.carregarItensProdutos(0);
  }

  onPageChangeProdutos(event: any) {
    this.loadingTableItens = true;
    if (this.itensProdutosPaginados) {
      this.numeroPaginaProduto = event.first / event.rows;
    }
    this.carregarItensProdutos(this.numeroPaginaProduto);
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  limparFormulario() {
    this.form?.reset();
    this.listaItensSaidaEstoque = [];
  }

}
